import React from 'react';
import { IDataBox } from '../DataBox.types';
import { Content } from '../DataBox.styles';

export default function DataBoxContent({ children, testId = 'data-box-content' }: IDataBox) {
  return <Content data-testid={testId}>{children}</Content>;
}
